module.exports = __webpack_public_path__ + "img/streetfood.5d3a93a1.svg";